// URLs
export const ARTICLE_IMAGE_BASE = 'https://images.ctfassets.net'
export const STATIC_IMAGE_BASE = 'https://static.masterclass.com'
export const CLOUDFLARE_IMAGE_PREFIX =
  'https://www.masterclass.com/cdn-cgi/image'
